export const usersEndpoints = (builder) => ({
    getUserProfile: builder.query({
        query: (userId) => ({ url: `/users/profile/${userId}`, method: 'get' })
    }),
    getUserPinStatus: builder.query({
        query: ({ userId }) => ({ url: `/users/${userId}/pin-status`, method: 'get' })
    }),
    clearUserPinSuspension: builder.mutation({
        query: ({ userId }) => ({ url: `/users/${userId}/pin/clear-suspension`, method: 'post' })
    }),
    allowUserPinReset: builder.mutation({
        query: ({ userId }) => ({ url: `/users/${userId}/pin/allow-reset`, method: 'post' })
    }),
    getUserGroups: builder.query({
        query: () => ({ url: `/users/groups`, method: 'get' })
    }),
    searchUsers: builder.query({
        query: ({ query } = {}) => ({ url: `/users?query=${encodeURIComponent(query || "")}`, method: 'get' })
    }),
    MigrateToGroup: builder.mutation({
        query: ({ userId, nationality, username, meta }) => ({ url: `/users/${userId}/user-group/change`, method: 'put', body: { meta, nationality, username } })
    }),
    UpdateUserStatus: builder.mutation({
        // query: ({ userId, username, status, reason, meta }) => ({ url: `/users/${userId}/status`, method: 'put', body: { meta, username, status, reason } })
        query: ({ userId, username, status, meta }) => ({ url: `/users/${userId}/status`, method: 'put', body: { meta, username, status } })
    }),
})

export const accountEndpoints = (builder) => ({
    updateAccountMeta: builder.mutation({
        query: ({ userId, accountId, fields, meta }) => ({ url: `/users/account/${userId}/${accountId}/meta`, method: 'patch', body: { fields, meta } }),
    }),
    appendAccount: builder.mutation({
        query: ({ userId, meta, ...data }) => ({ url: `/users/account/${userId}/append`, method: 'post', body: { ...data, meta } }),
    }),
    triggerAiAccountReview: builder.mutation({
        query: ({ userId, accountId }) => ({ url: `/ai/account-review`, method: 'post', body: { accountId, userId } }),
    }),
    getAiAccountReview: builder.query({
        query: ({ jobId }) => ({ url: `/ai/account-review/${jobId}`, method: 'get' }),
    }),
})
